/** A Grafana IRM team doc, as written by the backend's refresh route. */
export type GrafanaIrmTeam = {
  id: string;
  name: string;
  /** Absent when the refresh couldn't read IRM's integrations. */
  hasPagingChain?: boolean;
};

/** Labels a team for a picker, flagging a team with no direct-paging chain:
 * paging it notifies every member, yet nobody counts as on call for it. */
export const grafanaIrmTeamLabel = ({
  hasPagingChain,
  name,
}: Pick<GrafanaIrmTeam, "hasPagingChain" | "name">) =>
  hasPagingChain === false ? `${name} (no paging chain)` : name;
